import React from 'react';

import OnsitePing, { Props as OnsitePingProps } from './onsite_ping';

import { PingSurveyVariant, PingBody } from 'js/user_tagging/PingBody';
import { UserTaggingQuestion } from 'js/user_tagging/types';
import { recordShow } from 'js/utils/dismissibles';
import { fsEvent, initializeFullstory, UserLike } from 'js/fullstory';
import User from 'js/core_post_webpack/models/user';

interface Props extends OnsitePingProps {
  variant: PingSurveyVariant;
  questions: UserTaggingQuestion[];
  user?: UserLike;
}

const alreadyAnswered = () =>
  !User.current.admin &&
  window.localStorage.getItem('USER_TAGGING_PING_COMPLETED');

export default class UserTaggingPing extends OnsitePing<Props> {
  closeRef: React.RefObject<HTMLButtonElement>;
  constructor(props: Props) {
    super(props);
    this.closeRef = React.createRef();
  }

  componentDidMount() {
    if (alreadyAnswered()) {
      return;
    }
    recordShow('UserTaggingPingSurveyV3');

    if (this.props.user) {
      fsEvent('UserTaggingPingSurveyV3');
      initializeFullstory(this.props.user, true);
    }
  }

  renderBasePing(): React.ReactNode {
    if (alreadyAnswered()) {
      return null;
    }
    return (
      <PingBody variant={this.props.variant} questions={this.props.questions} />
    );
  }
}
